import React from "react";
import NavBar from "./components/Nav";
import HomeScreen from "./screens/HomeScreen";
import EventScreen from "./screens/EventScreen";
import AboutUsScreen from "./screens/AboutUsScreen";
import CommunityScreen from "./screens/CommunityScreen";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route exact path="/about" element={<AboutUsScreen/>} />
        <Route exact path="/communities" element={<CommunityScreen />} />
        <Route exact path="/events" element={<EventScreen />} />
        <Route exact path="/home" element={<HomeScreen />} />
        <Route exact path="/" element={<HomeScreen />} />
      </Routes>
    </Router>
  );
};

export default App;
